import { render, staticRenderFns } from "./addContacts.vue?vue&type=template&id=4de75308&scoped=true&"
import script from "./addContacts.vue?vue&type=script&lang=js&"
export * from "./addContacts.vue?vue&type=script&lang=js&"
import style0 from "./addContacts.vue?vue&type=style&index=0&id=4de75308&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de75308",
  null
  
)

export default component.exports